import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ArrowUp = ({ className }) => {
  return (
    <svg
      viewBox='0 0 408 408'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-arrow-up', { [className]: className })}
    >
      <path
        d='M408 376.696V408H0V376.696C99.9837 376.696 181.048 285.367 181.048 172.712V64.9823L87.8862 158.144L55.435 125.693L181.048 0.063755V0H226.952V0.063755L353.458 126.57L321.006 159.021L226.952 64.9663V174.354C226.952 278.195 295.807 363.897 384.873 376.696H408ZM271.676 191.377L304.813 224.513L321.038 208.288L270.863 158.112H247.911V174.37C247.911 273.987 319.588 354.733 408 354.733V331.781C337.391 331.781 279.087 270.21 271.676 191.377ZM0 331.765V354.717C88.4122 354.717 160.089 273.955 160.089 174.354V158.096H137.137L86.9618 208.272L103.187 224.497L136.324 191.361C128.913 270.194 70.6086 331.765 0 331.765Z'
        fill='currentColor'
      />
    </svg>
  );
};

ArrowUp.propTypes = {
  className: PropTypes.string,
};

export default ArrowUp;
